module.exports = __webpack_public_path__ + "static/media/power.d93e3661.jpg";